module.exports = __webpack_public_path__ + "img/close.52d216d1.svg";